import {LOCATION_CHANGE} from 'react-router-redux';

import {SET_NAVIGATION_CONTEXT, CLOSE_SIDEBAR, OPEN_SIDEBAR, TOGGLE_SIDEBAR} from '../actions/navigation';

export default(state = {
    context: {},
    sidebar: false
}, action) => {
    switch (action.type) {
        case LOCATION_CHANGE:
        case CLOSE_SIDEBAR:
            return {
                ...state,
                sidebar: false
            };
        case OPEN_SIDEBAR:
            return {
                ...state,
                sidebar: true
            };
        case TOGGLE_SIDEBAR:
            return {
                ...state,
                sidebar: !state.sidebar
            };
        case SET_NAVIGATION_CONTEXT:
            return {
                ...state,
                context: {
                    ...state.context,
                    ...action.payload
                }
            };
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/navigation.js